import React, { useState, useEffect, useRef } from 'react';
import '../view-archer-styles.css';

//material UI
import { Avatar, Card, CardContent, CardActions, Divider, Grid, Stack, Typography } from '@mui/material/';
import { blue} from '@mui/material/colors';
import { DeleteOutline, Edit } from '@mui/icons-material/';

//components import
import AuditNote from '../dataObjects/AuditNote';

interface NoteCardProps {
    note: AuditNote;
    deleteNote: (noteId: number) => void;
    saveNote: () => void;
}

const AuditNoteCard = (props: NoteCardProps) => {

    let note = props.note;

    const deleteNote = (noteId: number) => {
        props.deleteNote(noteId);
    }

    const saveNote = () => {
        props.saveNote();
    }

    return (<Grid item xs={12} key={note.id}>
        <Card variant="outlined" className="note-card">
            <CardContent className="card-content">
                <Typography variant="body2" color="text.secondary">
                    {note.body}
                </Typography>
            </CardContent>
            <Divider light />
            <CardActions className="card-actions">
                <Grid item xs={8}>
                    <Stack
                        direction="row" spacing={2}
                        justifyContent="flex-start"
                        alignItems="center">
                        <Avatar className="small-avatar" sx={{bgcolor:blue[200]}}><span className="note-initial">{note.userInitials}</span></Avatar>
                        <span className="note-date">{note.date}</span>
                    </Stack>
                </Grid>
                <Grid item xs={4} sx={{
                    justifyContent: 'flex-end'
                }}>
                    <DeleteOutline className="small-icon is-clickable" onClick={() =>deleteNote(note.id)} />
                    <Edit className="small-icon is-clickable" onClick={saveNote} />
                </Grid>
            </CardActions>
        </Card>
    </Grid>);
}

export default AuditNoteCard